export default __webpack_public_path__ + "static/media/rowboat.0f4dffb6.png";